<template>
  <v-layout class="main" column>
    <div class="page-title">Account</div>
    <v-layout class="profile-cards" column align-space-between>
      <v-card>
        <v-toolbar color="cyan" height="46px" dark>
          <v-toolbar-title>User info</v-toolbar-title>
        </v-toolbar>
        <v-list two-line>
          <v-layout class="profile-changing profile-card-content" row justify-space-between align-center>
            <div class="profile-changing-text">{{ profile.email }}</div>
            <v-dialog v-model="changePassword" width="500">
              <template #activator="{ on }">
                <v-btn v-on="on" color="cyan">Change password</v-btn>
              </template>
              <v-card>
                <v-card-title class="headline cyan" primary-title> Change password </v-card-title>
                <v-card-text>
                  <input
                    v-model="profile.oldPassword"
                    :class="{
                      'wrong-input':
                        ($v.profile.oldPassword.$invalid && showErrors) || currentInvalidPassword,
                    }"
                    type="password"
                    placeholder="Old Password"
                    id="old-pass"
                    @input="clearOldPasswordValidation"
                    class="custom-input"
                  />
                  <input
                    v-model="profile.password"
                    :class="{ 'wrong-input': $v.profile.password.$invalid && showErrors }"
                    type="password"
                    placeholder="New Password"
                    id="new-pass"
                    class="custom-input"
                  />
                  <input
                    v-model="profile.repeatPassword"
                    :class="{ 'wrong-input': $v.profile.repeatPassword.$invalid && showErrors }"
                    type="password"
                    placeholder="Repeat New Password"
                    id="repeat-pass"
                    class="custom-input"
                  />
                  <p v-if="showErrors || currentInvalidPassword" class="error-message">
                    <span v-if="currentInvalidPassword"
                      >The current password you entered is incorrect.</span
                    >
                    <span v-if="!$v.profile.oldPassword.required">Old Password is required.</span>
                    <span v-if="!$v.profile.oldPassword.minLength"
                      >Old Password must have at least
                      {{ $v.profile.password.$params.minLength.min }} letters.</span
                    >
                    <span v-if="!$v.profile.password.required">New Password is required.</span>
                    <span v-if="!$v.profile.password.minLength"
                      >New Password must have at least
                      {{ $v.profile.password.$params.minLength.min }} letters.</span
                    >
                    <span v-if="!$v.profile.repeatPassword.sameAsPassword"
                      >Repeat New Passwords must be identical.</span
                    >
                  </p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    id="cancel-change-pass"
                    color="blue-grey lighten-4"
                    @click="changePassword = false"
                  >
                    Cancel and close
                  </v-btn>
                  <v-btn id="change-pass" color="green lighten-3" @click="saveNewPassword()">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-list>
      </v-card>
      <v-card v-if="showProfileBillingSection">
        <v-toolbar height="46px" color="orange lighten-1" dark>
          <v-toolbar-title>Billing</v-toolbar-title>
        </v-toolbar>
        <v-list two-line>
          <v-layout class="profile-changing profile-card-content" row justify-space-between align-center>
            <div class="profile-changing-text">Beta-tester (valid until beta-testing period ends)</div>
            <v-dialog v-model="dialogBilling" width="500">
              <template #activator="{ on }">
                <v-btn v-on="on" color="orange lighten-1">Change</v-btn>
              </template>
              <v-card>
                <v-card-title class="headline orange lighten-1" primary-title>
                  Billing
                </v-card-title>
                <v-card-text> </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-grey lighten-4" @click="dialogBilling = false">
                    Cancel and close
                  </v-btn>
                  <!--                                    <v-btn-->
                  <!--                                            color="green lighten-3"-->
                  <!--                                            @click="saveNewPassword()"-->
                  <!--                                    >-->
                  <!--                                        Save-->
                  <!--                                    </v-btn>-->
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-list>
      </v-card>
      <v-card v-if="showProfileApiSection">
        <v-toolbar height="46px" color="blue-grey lighten-3" dark>
          <v-toolbar-title>API</v-toolbar-title>
        </v-toolbar>
        <v-list two-line>
          <v-layout
            class="profile-changing profile-card-content profile-changing--column"
            column
            justify-center
            align-start
          >
            <span
              >API key: <span style="cursor: text">{{ profile.key }}</span>
              <v-tooltip bottom v-if="profile.key">
                <template #activator="{ on }">
                  <img
                    @click="copyToClipboard(profile.key)"
                    style="vertical-align: sub"
                    src="../assets/copy.png"
                    class="copy ml-4"
                    alt="Copy"
                    v-on="on"
                  />
                </template>
                <div>COPY</div>
              </v-tooltip>
            </span>
            <span
              >Endpoint:
              <a :href="simpleData.apiEndpoint" target="_blank">{{
                simpleData.apiEndpoint
              }}</a></span
            >
            <span
              >Docs: <a :href="simpleData.docs" target="_blank">{{ simpleData.docs }}</a></span
            >
          </v-layout>
        </v-list>
      </v-card>
      <v-card>
        <v-toolbar height="46px" color="teal lighten-3" dark>
          <v-toolbar-title>Theme configurations</v-toolbar-title>
        </v-toolbar>
        <v-list two-line>
          <v-layout class="profile-changing profile-card-content" row justify-space-between align-center>
            <div class="profile-changing-text">Changing Your Site Colors</div>
            <v-dialog v-model="changeColors" width="60%">
              <template #activator="{ on }">
                <v-btn v-on="on" color="teal lighten-3">Change colors</v-btn>
              </template>
              <v-card>
                <v-card-title class="headline cyan" primary-title> Change colors </v-card-title>
                <v-card-text :style="{ height: openColorsDialog ? '370px' : 'auto' }">
                  <v-layout row justify-space-between align-center>
                    <span>Header Color</span>
                    <swatches
                      v-model="colorHeader"
                      @open="openColorsDialog = true"
                      @close="openColorsDialog = false"
                      popover-to="left"
                      row-length="6"
                      show-border
                      :colors="colors"
                    />
                  </v-layout>
                  <br />
                  <v-layout row justify-space-between align-center>
                    <span>Background Color</span>
                    <swatches
                      v-model="color"
                      @input="saveColors('main')"
                      @open="openColorsDialog = true"
                      @close="openColorsDialog = false"
                      popover-to="left"
                      row-length="6"
                      show-border
                      :colors="colors"
                    />
                  </v-layout>
                  <br />
                  <v-layout row justify-space-between align-center>
                    <span>Background Url</span>
                    <input
                      type="url"
                      v-model="backgroundImage"
                      placeholder="Paste image url"
                      style="width: 50%; padding: 4px"
                    />
                  </v-layout>
                  <br />
                  <v-layout row justify-space-between align-center>
                    <span>Prepared images</span>
                    <span
                      @click="
                        choosedImage(
                          'http://cpclub.in/wp-content/uploads/2018/07/gaussian_blur_simple_background.jpg'
                        )
                      "
                      class="prepared-images"
                      style="
                        background-image: url('http://cpclub.in/wp-content/uploads/2018/07/gaussian_blur_simple_background.jpg');
                      "
                    >
                    </span>
                    <span
                      @click="
                        choosedImage(
                          'https://hookagency.com/wp-content/uploads/2015/11/ice-cold-blue-to-yellow-gradient-background.jpg'
                        )
                      "
                      class="prepared-images"
                      style="
                        background-image: url('https://hookagency.com/wp-content/uploads/2015/11/ice-cold-blue-to-yellow-gradient-background.jpg');
                      "
                    >
                    </span>
                    <span
                      @click="
                        choosedImage(
                          'https://webgradients.com/public/webgradients_png/052%20Kind%20Steel.png'
                        )
                      "
                      class="prepared-images"
                      style="
                        background-image: url('https://webgradients.com/public/webgradients_png/052%20Kind%20Steel.png');
                      "
                    >
                    </span>
                    <span
                      @click="
                        choosedImage(
                          'https://www.xmple.com/wallpaper/gradient-white-blue-linear-1920x1080-c2-faebd7-e0ffff-a-165-f-14.svg'
                        )
                      "
                      class="prepared-images"
                      style="
                        background-image: url('https://www.xmple.com/wallpaper/gradient-white-blue-linear-1920x1080-c2-faebd7-e0ffff-a-165-f-14.svg');
                      "
                    >
                    </span>
                    <span
                      @click="
                        choosedImage('https://images5.alphacoders.com/652/thumb-1920-652530.jpg')
                      "
                      class="prepared-images"
                      style="
                        background-image: url('https://images5.alphacoders.com/652/thumb-1920-652530.jpg');
                      "
                    >
                    </span>
                  </v-layout>
                  <br />
                  <v-layout row justify-space-between align-center>
                    <div></div>
                    <v-btn @click="setDefaultColors" color="info">Set Default Colors</v-btn>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-grey lighten-4"
                    @click="
                      changeColors = false;
                      openColorsDialog = false;
                    "
                  >
                    Cancel and close
                  </v-btn>
                  <v-btn color="green lighten-3" @click="saveColors"> Save </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-list>
      </v-card>
      <v-card>
        <v-toolbar height="46px" color="red darken-1" dark>
          <v-toolbar-title>Danger zone</v-toolbar-title>
        </v-toolbar>
        <v-expansion-panels flat>
          <v-expansion-panel>
            <v-expansion-panel-header>&#9888; Danger zone</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout class="profile-changing" row justify-space-between align-center>
                <div class="profile-changing-text">
                  Deleting your account is permanent and cannot be undone.
                </div>
                <v-dialog v-model="deleteAccountDialog" width="500">
                  <template #activator="{ on }">
                    <v-btn v-on="on" color="red darken-1" dark>Delete my account</v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline red darken-1" primary-title>
                      Delete account
                    </v-card-title>
                    <v-card-text>
                      <p>
                        Your account and API key are deleted immediately and cannot be restored.
                        Auctions you created stay in the auction registry and keep running, but no
                        new bidders can register on them and you will lose access to their bids.
                      </p>
                      <input
                        v-model="confirmEmail"
                        type="email"
                        placeholder="type your email to confirm"
                        style="width: 100%; padding: 8px; margin-top: 8px"
                      />
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue-grey lighten-4"
                        @click="
                          deleteAccountDialog = false;
                          confirmEmail = '';
                        "
                      >
                        Cancel and close
                      </v-btn>
                      <v-btn
                        class="delete-confirm-btn"
                        :color="confirmMatches ? 'red darken-1' : undefined"
                        :dark="confirmMatches"
                        :disabled="!confirmMatches"
                        @click="deleteAccount()"
                      >
                        Delete my account
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-layout>
  </v-layout>
</template>

<script>
import errorParser from '@/utils/errorParser';
import AuthorizService from '@/services/AuthorizService';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { mapActions, mapMutations, mapState } from 'vuex';
import Swatches from 'vue-swatches';
import 'vue-swatches/dist/vue-swatches.min.css';

export default {
  name: 'Profile',
  data() {
    return {
      currentInvalidPassword: false,
      showErrors: false,
      dialogBilling: false,
      showProfileBillingSection: FEATURE_FLAGS.showProfileBillingSection,
      showProfileApiSection: FEATURE_FLAGS.showProfileApiSection,
      changePassword: false,
      openColorsDialog: false,
      profile: {
        name: '',
        password: '',
        repeatPassword: '',
        oldPassword: '',
        email: '',
        key: '',
        apiEndpoint: '',
        docs: '',
      },
      backgroundImage: '',
      color: '',
      colorHeader: '',
      colors: [
        ['#dcdcdc', '#BDBDBD', '#CFD8DC', '#B0BEC5', '#ffffff'],
        ['#D7CCC8', '#FFF3E0', '#DCEDC8', '#F1F8E9', '#B2DFDB'],
        ['#BBDEFB', '#b7faf4', '#96f0ea', '#b9f5f1', '#dcfaf8'],
        ['#C8E6C9', '#FFEBEE', '#FFF8E1', '#9E9E9E', '#757575'],
      ],
      changeColors: false,
      deleteAccountDialog: false,
      confirmEmail: '',
    };
  },
  components: {
    Swatches,
  },
  created() {
    this.setLoading({ show: true, text: 'Loading...' });
    this.inspectToken().then(() => {
      AuthorizService.getProfile()
        .then((response) => {
          this.profile.name = response.data.username;
          // this.profile.user.phone = response.data.extendedUser.phone
          this.profile.email = response.data.email;
          this.profile.key = response.data.apiKey;
          this.profile.apiEndpoint = response.data.apiEndpoint;
          this.profile.docs = response.data.docs;

          // if (response.data.extendedUser.image) this.userLogoServer = response.data.extendedUser.image
          // if (response.data.extendedUser.company.image) this.companyLogoServer = response.data.extendedUser.company.image

          // this.profile.company = response.data.extendedUser.company
        })
        .catch((error) => {
          console.log(error);
        });
    });
    this.setLoading({ show: false, text: '' });
  },
  computed: {
    ...mapState(['simpleData']),
    confirmMatches() {
      return (
        this.confirmEmail.trim().toLowerCase() === this.profile.email.trim().toLowerCase() &&
        this.confirmEmail.length > 0
      );
    },
  },
  watch: {
    changePassword() {
      this.profile.oldPassword = '';
      this.profile.password = '';
      this.profile.repeatPassword = '';
    },
  },
  methods: {
    ...mapActions(['setLoading', 'showSnackbar', 'inspectToken']),
    ...mapMutations(['setBackGroundColor', 'setColorHeader', 'setBackgroundImage', 'logout']),
    copyToClipboard(data) {
      let vm = this;
      this.$copyText(data).then(() => {
        vm.succesCopyToClipboard();
      });
    },
    succesCopyToClipboard() {
      this.showSnackbar('COPIED');
    },
    clearOldPasswordValidation() {
      this.currentInvalidPassword = false;
    },
    setDefaultColors() {
      this.setBackgroundImage('');
      this.setColorHeader('#ffffff');
      this.setBackGroundColor(this.color);
      localStorage.setItem('mainColor', this.color);
      this.changeColors = false;
    },
    choosedImage(url) {
      this.setBackgroundImage(url);
      localStorage.setItem('backgroundImage', url);
      this.changeColors = false;
    },
    saveColors(main) {
      if (main === 'main') {
        this.setBackgroundImage('');
        localStorage.setItem('backgroundImage', '');
      } else {
        if (this.backgroundImage.length > 10) {
          this.setBackgroundImage(this.backgroundImage);
          localStorage.setItem('backgroundImage', this.backgroundImage);
        }
      }
      this.openColorsDialog = false;
      this.setBackGroundColor(this.color);
      localStorage.setItem('mainColor', this.color);
      this.setColorHeader(this.colorHeader);
      localStorage.setItem('colorHeader', this.colorHeader);
      this.changeColors = false;
    },
    saveNewPassword() {
      this.showErrors = false;
      if (!this.$v.$invalid) {
        let jsonToSend = {
          old_password: this.profile.oldPassword,
          new_password: this.profile.password,
        };
        this.setLoading({ show: true, text: 'Updating...' });
        AuthorizService.changePassword(jsonToSend)
          .then((resp) => {
            this.profile.oldPassword = '';
            this.profile.password = '';
            this.profile.repeatPassword = '';
            this.showSnackbar(resp.data);
            this.changePassword = false;
            this.setLoading({ show: false, text: '' });
          })
          .catch((error) => {
            this.setLoading({ show: false, text: '' });
            errorParser({
              error,
              setLoading: this.setLoading,
              showSnackbar: this.showSnackbar,
              onWrongPassword: () => {
                this.currentInvalidPassword = true;
              },
            });
          });
      } else {
        this.showErrors = true;
      }
    },
    deleteAccount() {
      if (!this.confirmMatches) return;
      this.setLoading({ show: true, text: 'Deleting...' });
      AuthorizService.deleteAccount({ email: this.confirmEmail })
        .then(() => {
          this.setLoading({ show: false, text: '' });
          this.deleteAccountDialog = false;
          this.showSnackbar('Your account has been deleted');
          this.logout();
        })
        .catch((error) => {
          errorParser({ error, setLoading: this.setLoading, showSnackbar: this.showSnackbar });
        });
    },
  },
  validations: {
    profile: {
      oldPassword: {
        required,
        minLength: minLength(4),
      },
      password: {
        required,
        minLength: minLength(4),
      },
      repeatPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  margin-top: 0;
  max-width: 700px;
  width: 700px;
  margin-right: auto;
  margin-left: auto;
  
  @media (max-width: 500px) {
    width: 100%;
  }
  &.layout.column {
    width: 98%;
  }
}

.profile-cards {
  gap: 16px;
}

.main .v-card {
  overflow: hidden;
  padding-bottom: 12px;
}

.main .v-list {
  padding: 10px 0;
}

.profile-changing {
  width: 100%;
  min-height: 64px;
  gap: 16px;
}

.profile-card-content {
  padding-left: 16px;
  padding-right: 16px;
}

.profile-changing--column {
  gap: 8px;
}

.profile-changing-text {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
  line-height: 1.4;
  padding: 8px 0;
}

.profile-changing .v-btn {
  flex-shrink: 0;
}
.delete-confirm-btn.v-btn--disabled {
  background-color: #e0e0e0 !important;
  color: rgba(0, 0, 0, 0.4) !important;
  opacity: 1;
  pointer-events: none;
  box-shadow: none !important;
}
::v-deep .v-expansion-panel-content__wrap {
  padding: 16px;
}
.avatar-custom {
  background-color: #ffffff !important;
  background-size: 100% !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.prepared-images {
  border-radius: 10px;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  height: 40px;
  width: 40px;
  border: 1px solid grey;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.custom-input[type='password'] {
  background-repeat: no-repeat;
  background-image: url('../assets/password.png');
}
.error-message {
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #fd6262;
}
.error-message span {
  display: block;
}
.wrong-input {
  outline: 2px solid #fd6262 !important;
}
.block {
  width: 48.5%;
}
.custom-input {
  background-position-y: center;
  background-position-x: 10px;
  padding-left: 50px;
  width: 100%;
  height: 46px;
  color: #216169;
  background-color: #c4c4c44d;
  font-size: 22px;
  
  margin-bottom: 17px;
}
.save {
  margin: -80px auto 0 auto;
}
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 139px;
  text-align: center;
  padding: 21px;
  background: #286d76;

  input {
    margin-top: -51px;
  }
  .username {
    margin-top: -47px;
    font-size: 14px;
    text-decoration: underline;
    color: #ffffff;
    font-weight: 400;
  }
  .user-logo {
    transform: translateY(-50%);
    cursor: pointer;
    box-shadow: 0 3px 9px 1px rgba(18, 13, 10, 0.17);
    border: 2px solid #2e7f89;
    width: 128px;
    height: 128px;
    background-color: #ffffff;
    border-radius: 50%;
    background-image: url('../assets/Vector_Smart_Object.png');
    background-position-x: center;
    background-position-y: 80%;
    position: relative;

    .tooltip {
      position: initial;
    }

    i.material-icons {
      z-index: 888;
      position: absolute;
      top: -6px;
      right: -4px;
    }
  }
  .company-logo {
    transform: translateY(-50%);
    cursor: pointer;
    box-shadow: 0 3px 9px 1px rgba(18, 13, 10, 0.17);
    border: 2px solid #2e7f89;
    width: 128px;
    color: rgba(47, 102, 109, 0.67);
    font-size: 19px;
    font-weight: 700;
    text-transform: uppercase;
    height: 128px;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: relative;

    .tooltip {
      position: initial;
    }

    i.material-icons {
      z-index: 888;
      position: absolute;
      top: -6px;
      right: -4px;
    }
  }
}
.copy {
  cursor: pointer;
}
.info-block {
  padding: 42px 0;
  height: 354px;
  background: #ffffff;
  color: #000000;
  font-size: 14px;
  font-weight: 400;

  .section {
    margin-bottom: 11px;
    display: flex;
    align-items: center;
    flex-direction: row;
    border: 1px solid rgba(46, 127, 137, 0.1);
    text-align: left;
    padding: 14px 0 14px 23px;
    border-left: 4px solid #286d76;

    img {
      margin-right: 17px;
    }
  }
}
input {
  width: 78%;
  background: #e3eef0;
  padding: 0 2px 2px 4px;
  opacity: 0.8;
  &:focus {
    outline: 2px solid #286d76;
  }
}
.textarea-span {
  width: 79%;
}
textarea {
  width: 79%;
  background: #e3eef0;
  padding: 2px;
  opacity: 0.8;
}
@media (max-width: 1400px) {
  .save {
    margin: 22px auto 0 auto;
  }
}
@media (max-width: 500px) {
  .profile-changing {
    flex-direction: column;
    align-items: flex-start;
  }

  .profile-changing .v-btn {
    width: 100%;
  }
}
</style>
